import React from 'react'

const Cancellation = () => {
  return (
      <div style={{ display: 'flex', flexDirection: 'column', padding: '20px', margin: '0 auto', color: '#fff', background: '#010C12', gap: '20px', textAlign: 'justify' }}>
          <h1 style={{ textTransform: 'capitalize' }}>Subscription Fees, Cancellation and Refund Policy</h1>
          <h2 style={{ textTransform: 'capitalize' }}>Subscription Fees</h2>
          <ol>
              <li>Credit card holder&apos;s account is automatically charged on the same date as the original transaction date on each corresponding month or on the final date of month if no corresponding date (January 31, 2020 subscription renews on February 28, 2020).</li>
              <li>Discounts, rebates or other special offers are only valid for the initial term; subscriptions renew at the then-current full subscription rates.</li>
              <li>MachineHack may terminate the subscription and these terms if it is unable to renew the subscription based on inaccurate or outdated credit card information.</li>
              <li>Right of access granted under these Terms is effective only upon payment of the subscription fees.
              </li>
          </ol>
          <h2 style={{ textTransform: 'capitalize' }}>Cancelling Account</h2>
          <ol>
              <li>You can cancel your subscription from your account profile page.
              </li>
              <li>Discounts, rebates or other special offers are only valid for the initial term; subscriptions renew at the then-current full subscription rates.</li>
              <li>The only valid method for canceling your Plan is via the cancellation link provided on your user &quot;dashboard&quot; page, accessible after logging in to the MachineHack Website. Requests to cancel by e-mail or phone are not considered, and do not accomplish, cancellation.
              </li>
              <li>Right of access granted under these Terms is effective only upon payment of the subscription fees.
              </li>
              <li>Once you cancel your membership subscription, you will not lose access immediately.
              </li>
              <li>Your membership will continue through the end of your current charge cycle. For example: If your credit card is charged on the 10th of the month and you cancel on April 25th, you will not lose access until the May 10th.
              </li>
          </ol>
          <h2 style={{ textTransform: 'capitalize' }}>Refunds</h2>
          <ol>
              <li>Subscription fees are non-refundable; except that you may cancel the renewed subscription.
              </li>
          </ol>
      </div>
  )
}

export default Cancellation
